import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ConnectionsIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        height='28'
        viewBox='0 0 24 24'
        width='28'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M13.5 3h3.75a1.25 1.25 0 0 1 1.25 1.25V8a2 2 0 1 0 0 4h1.75A1.25 1.25 0 0 1 21.5 13.25V17a1.25 1.25 0 0 1-1.25 1.25h-3.75a.75.75 0 0 1-.75-.75v-1.25a2 2 0 1 0-4 0v1.25a.75.75 0 0 1-.75.75h-3.5A1.25 1.25 0 0 1 6.25 17v-3.5a.75.75 0 0 0-.75-.75H4.25a2 2 0 1 1 0-4H5.5a.75.75 0 0 0 .75-.75v-3.75A1.25 1.25 0 0 1 7.5 3h3.75a.75.75 0 0 1 .75.75V5a2 2 0 1 0 4 0V3.75A.75.75 0 0 1 13.5 3Z'
            stroke='currentColor'
            strokeLinejoin='round'
            strokeWidth='1.6'
        />
    </svg>
);

export default ConnectionsIcon;
